// extracted by mini-css-extract-plugin
module.exports = {"list":"_29Ef7YIH"};